module.exports = __webpack_public_path__ + "static/l4-card-2-4da77dfd14c67e01e4b113bd17b42954.png";